import PropTypes from 'prop-types'

const Header = ({ title, backgroundImg }) => {
 

    return (
        <header className='header' style={{backgroundImage:{}}}>
            <h2 >{title}</h2>
        </header>
    )
}

Header.defaultProps = {
    title:  "CHANGE TITLE"
}

Header.propTypes = {
    title: PropTypes.string.isRequired
}

export default Header